import React, { useEffect } from "react";

const rawText = `Podmínky používání aplikace Věrnost

Verze: 1.0
Účinné od: 20.08.2026

1. Provozovatel a úvodní ustanovení

1.1. Provozovatelem mobilní aplikace a služby Věrnost je Ivan Kuznetsov, IČO 19911173, místo podnikání: Nové sady 988/2, 602 00 Staré Brno, e-mail: podpora.vernostapp@gmail.com (dále jen „Provozovatel“ nebo „Věrnost“).

1.2. Tyto podmínky upravují používání mobilní aplikace Věrnost, souvisejících webových stránek a služeb určených koncovým uživatelům (dále jen „Aplikace“).

1.3. Věrnost je digitální platforma, která umožňuje uživatelům zejména objevovat zapojené podniky, připojovat se k jejich věrnostním programům, sbírat digitální návštěvy nebo razítka, získávat odměny, využívat kupóny a další dostupné funkce.

1.4. Samotné zboží, služby, slevy, odměny a jiná plnění nabízená zapojenými podniky poskytují příslušné podniky, nikoli Provozovatel, není-li výslovně uvedeno jinak.

2. Registrace a uživatelský účet

2.1. Některé funkce Aplikace jsou dostupné pouze registrovaným uživatelům.

2.2. Registrace a přihlášení mohou podle aktuální verze Aplikace probíhat zejména prostřednictvím telefonního čísla a ověřovacího kódu nebo prostřednictvím podporované služby třetí strany, například Google.

2.3. Uživatel je povinen uvádět pravdivé a aktuální údaje a chránit přístup ke svému účtu před zneužitím.

2.4. Uživatelský účet je určen pro osobní použití konkrétního uživatele. Uživatel nesmí účet zneužívat, neoprávněně sdílet nebo používat způsobem, který narušuje fungování Aplikace.

2.5. Uživatel může požádat o zrušení účtu prostřednictvím funkce dostupné v Aplikaci nebo kontaktováním podpory, pokud je takový postup v konkrétní situaci nutný.

3. Bezplatná verze Věrnost

3.1. Věrnost může být používána v bezplatném tarifu.

3.2. Bezplatný tarif umožňuje uživateli být současně zapojen nejvýše do 3 věrnostních programů, není-li v Aplikaci výslovně uvedeno jinak v souvislosti s dočasnou akcí nebo změnou služby.

3.3. Rozsah dalších bezplatných funkcí se řídí aktuální nabídkou zobrazenou v Aplikaci.

4. Věrnost Premium

4.1. Uživatel si může aktivovat placený tarif Věrnost Premium.

4.2. Premium může zahrnovat zejména: - neomezený počet věrnostních programů; - Premium návštěvy; - přístup ke kupónům a jejich využívání podle podmínek konkrétní nabídky; - další funkce výslovně uvedené v Aplikaci jako součást Premium.

4.3. Aktuální cena, délka předplatného a přesný rozsah Premium funkcí jsou uživateli zobrazeny před potvrzením nákupu v Aplikaci a v příslušném obchodě s aplikacemi. Marketingové informace na webu mají informativní charakter; rozhodující jsou informace zobrazené při nákupu.

5. Nákup, obnova a zrušení Premium

5.1. Premium pro iOS je pořizováno prostřednictvím systému nákupů společnosti Apple a Premium pro Android prostřednictvím systému nákupů Google Play, podle platformy uživatele.

5.2. Platbu zpracovává příslušný provozovatel obchodu s aplikacemi. Provozovatel Věrnost běžně nezískává úplné údaje o platební kartě uživatele.

5.3. Předplatné se může automaticky obnovovat podle podmínek příslušného obchodu s aplikacemi, dokud jej uživatel nezruší.

5.4. Správa, zrušení předplatného, účtování a případné vrácení platby se řídí také pravidly Apple App Store nebo Google Play. Uživatel spravuje předplatné prostřednictvím svého účtu u příslušného obchodu, není-li v Aplikaci zpřístupněn odkaz vedoucí přímo do tohoto nastavení.

5.5. Zrušení automatické obnovy samo o sobě zpravidla neukončuje již zaplacené období; Premium zůstává dostupné do konce období, které uživatel již uhradil, podle údajů poskytnutých příslušným obchodem.

5.6. Technické vyhodnocení stavu předplatného může být zajišťováno prostřednictvím služby třetí strany určené ke správě mobilních předplatných.

6. Věrnostní programy podniků

6.1. Podmínky konkrétního věrnostního programu, počet potřebných návštěv, druh odměny, doba platnosti kupónu a další pravidla stanovuje příslušný zapojený podnik v rozsahu umožněném platformou.

6.2. Věrnost poskytuje technické prostředí pro evidenci a zobrazení programu. Za dostupnost, kvalitu, zákonnost a skutečné poskytnutí zboží, služby, slevy nebo odměny odpovídá příslušný podnik.

6.3. Informace o podniku a jeho nabídce jsou zobrazovány na základě údajů poskytnutých nebo spravovaných podnikem. Věrnost může zjevné chyby opravovat nebo požadovat jejich opravu.

7. Návštěvy, razítka a QR

7.1. Digitální návštěva nebo razítko se připisuje způsobem podporovaným Aplikací, typicky po ověření QR kódu zákazníka oprávněným pracovníkem podniku.

7.2. Uživatel nemá právo získávat návštěvy, razítka nebo odměny podvodným, automatizovaným nebo jinak neoprávněným způsobem.

7.3. V případě zjevné technické chyby, duplicitního zápisu, podvodu nebo zneužití může být chybný záznam po přiměřeném ověření opraven nebo odstraněn.

8. Odměny, Premium návštěvy a kupóny

8.1. Nárok na odměnu vzniká podle pravidel konkrétního programu zobrazených v Aplikaci.

8.2. Věrnost technicky eviduje stav programu nebo nárok zobrazený v Aplikaci; samotnou odměnu poskytuje podnik, který ji nabídl.

8.3. Premium návštěvy a kupóny mohou být dostupné pouze uživatelům s aktivním Premium podle pravidel konkrétní funkce nebo nabídky.

8.4. U kupónu mohou být stanoveny podmínky, zejména doba platnosti, konkrétní provozovna, jednorázové použití, omezení kombinace s jinými akcemi nebo další podmínky jasně uvedené před využitím kupónu.

9. Hodnocení a uživatelský obsah

9.1. Pokud Aplikace umožňuje hodnocení nebo recenze, uživatel odpovídá za obsah, který zveřejní.

9.2. Je zakázáno zveřejňovat obsah protiprávní, výhružný, nenávistný, klamavý, hrubě urážlivý, porušující práva třetích osob nebo nesouvisející s hodnocenou zkušeností.

9.3. Věrnost může obsah skrýt nebo odstranit, pokud je v rozporu s těmito podmínkami, právními předpisy nebo je zjevně zneužívající.

10. Povinnosti uživatele a zakázané jednání

10.1. Uživatel nesmí zejména: - obcházet technická nebo tarifní omezení; - vytvářet fiktivní návštěvy nebo manipulovat s odměnami; - neoprávněně zasahovat do Aplikace, API nebo účtů jiných osob; - používat Aplikaci k protiprávní činnosti; - zneužívat chyby nebo bezpečnostní nedostatky.

10.2. Při závažném nebo opakovaném porušení může Věrnost přístup k účtu přiměřeně omezit, pozastavit nebo ukončit.

11. Dostupnost a změny služby

11.1. Věrnost usiluje o dostupnost a řádné fungování služby, nemůže však zaručit nepřetržitý provoz bez výpadků.

11.2. Služba může být dočasně omezena zejména z důvodu údržby, aktualizace, bezpečnostního incidentu, výpadku infrastruktury nebo zásahu třetí strany.

11.3. Věrnost může funkce rozvíjet, měnit nebo ukončovat. Pokud by změna významně zasáhla do placené služby uživatele, bude postupováno v souladu s použitelnými právními předpisy a pravidly příslušného obchodu s aplikacemi.

12. Odpovědnost

12.1. Věrnost odpovídá za své povinnosti v rozsahu stanoveném právními předpisy.

12.2. Věrnost není poskytovatelem jídla, nápojů ani jiného zboží či služeb nabízených partnerskými podniky a neodpovídá za jejich kvalitu, bezpečnost nebo plnění závazků podniku vůči zákazníkovi, pokud právní předpis nestanoví jinak.

12.3. Tím nejsou dotčena práva spotřebitele ani odpovědnost, kterou nelze podle zákona vyloučit nebo omezit.

13. Ochrana osobních údajů

13.1. Zpracování osobních údajů je popsáno v samostatném dokumentu Zásady ochrany osobních údajů Věrnost.

13.2. Přijetí těchto Podmínek není samo o sobě souhlasem se všemi způsoby zpracování osobních údajů. Pokud je pro konkrétní zpracování vyžadován souhlas, bude vyžádán samostatně.

14. Ukončení účtu

14.1. Uživatel může svůj účet zrušit způsobem dostupným v Aplikaci.

14.2. Smazání účtu nemusí automaticky zrušit předplatné vedené u Apple nebo Google. Uživatel je odpovědný za zrušení automatické obnovy v příslušném obchodě, pokud Aplikace výslovně nepotvrdí jiný postup.

14.3. Některé údaje mohou být po zrušení účtu uchovány po dobu vyžadovanou právními předpisy nebo nezbytnou pro ochranu právních nároků; podrobnosti stanoví Zásady ochrany osobních údajů.

15. Spotřebitelská práva a řešení sporů

15.1. Právní vztahy se řídí právem České republiky, aniž jsou dotčena kogentní práva spotřebitele podle práva jeho obvyklého bydliště, pokud se použijí.

15.2. Spotřebitel může uplatnit svá práva a reklamace prostřednictvím e-mailu podpora.vernostapp@gmail.com.

15.3. K mimosoudnímu řešení spotřebitelských sporů je v České republice příslušná Česká obchodní inspekce (ČOI), pokud je pro daný spor věcně příslušná.

15.4. Pravidla pro vrácení plateb za nákup uskutečněný prostřednictvím Apple App Store nebo Google Play se řídí také pravidly příslušné platformy a použitelnými právními předpisy.

16. Změny podmínek

16.1. Věrnost může tyto Podmínky přiměřeně měnit zejména v návaznosti na změny služby, právních předpisů nebo obchodního modelu.

16.2. Aktuální verze bude vždy zveřejněna na webu Věrnost s uvedením data účinnosti. O významných změnách může být registrovaný uživatel informován také v Aplikaci nebo jiným vhodným způsobem.

17. Závěrečná ustanovení

17.1. Pokud je některé ustanovení neplatné nebo neúčinné, nemá to samo o sobě vliv na ostatní ustanovení.

17.2. Kontaktní e-mail Provozovatele: podpora.vernostapp@gmail.com.`;

export default function PodminkyPouzivani({ renderHeader, renderFooter }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Podmínky používání aplikace Věrnost";
  }, []);

  const lines = rawText.split("\n").map(line => line.trim()).filter(line => line.length > 0);

  return (
    <div className="min-h-screen bg-[#FDFDFD] text-[#111111] font-sans antialiased selection:bg-[#FF5A00]/10 selection:text-[#FF5A00]">
      {renderHeader()}

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-left">
        {/* Document Title Header */}
        <div className="border-b-2 border-[#FF5A00]/20 pb-8 mb-10">
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-neutral-900 leading-tight mb-4">
            Podmínky používání aplikace Věrnost
          </h1>
          <div className="flex flex-wrap gap-4 sm:gap-6 text-sm font-bold text-neutral-500">
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Verze: 1.0</span>
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Účinné od: 20.08.2026</span>
          </div>
        </div>

        {/* Legal Text Content */}
        <div className="space-y-6">
          {lines.slice(3).map((line, idx) => {
            // If the line is a numbered main section (e.g. "1. Provozovatel a úvodní ustanovení")
            const isMainHeading = /^\d+\.\s+[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]/.test(line);
            
            if (isMainHeading) {
              return (
                <h2 
                  key={idx} 
                  className="font-heading font-extrabold text-xl sm:text-2xl text-neutral-900 mt-10 mb-4 pt-4 border-b border-neutral-100 pb-2"
                >
                  {line}
                </h2>
              );
            }

            // If the line starts with a list bullet (e.g. "- neomezený počet") or contains inline bullets
            if (line.includes(" - ")) {
              const parts = line.split(" - ");
              return (
                <div key={idx} className="mb-4">
                  <p className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-2">{parts[0]}</p>
                  <div className="space-y-1">
                    {parts.slice(1).map((part, pIdx) => (
                      <div key={pIdx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                        <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                        <span>{part.trim()}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            const isBullet = line.startsWith("-");
            if (isBullet) {
              return (
                <div key={idx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                  <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                  <span>{line.substring(1).trim()}</span>
                </div>
              );
            }

            // Normal paragraph or subsection
            return (
              <p 
                key={idx} 
                className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-4"
              >
                {line}
              </p>
            );
          })}
        </div>
      </main>

      {renderFooter()}
    </div>
  );
}
